'use strict';

module.exports = {
    base: 'network',

    lan: 'ethernet',
    lanAuto: 'ethernetAuto',

    lanManualElement1: 'ethernetManualElement1',
    lanManualElement2: 'ethernetManualElement2',
    lanManualElement3: 'ethernetManualElement3',
    lanManualElement4: 'ethernetManualElement4',

    lanNoIp: 'ethernetNoIp',
    lanOptDns: 'lanOptDns',

    pppoe: 'pppoe',
    pppoeDnsElement1: 'pppoeDnsElement1',
    pppoeDnsElement2: 'pppoeDnsElement2',
    pppoeDnsElement3: 'pppoeDnsElement3',
    pppoeDnsElement4: 'pppoeDnsElement4',

    wifi: 'wifi',

    wifiList: 'wifiListI',

    wifiAdd: 'wifiAdd',
    wifiAddElement: 'wifiAddElement',
    wifiEnable: 'wifiEnableFlag',
    //upnp: 'upnp',

    multicast: 'multicast',
    multicastE: 'multicastE',

    igmp: 'igmp',

    info: 'networkInfo',
    infoLan: 'networkInfoLan',
    infoPPPOE: 'networkInfoPPPPOE',
    infoWifi: 'networkInfoWifi'
};
